import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CfetCoreModule } from '../cfet-core/cfet-core.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AbsMessagesModule, AbsTooltipModule, AbsExpandCollapseModule, AbsModalsAndAlertsModule } from '@att-ebiz/abs-components-bc';
import {
  AlertErrorComponent, PageTitleComponent, LoadSpinnerComponent, ActivationSuccessComponent,
  MessageTooltipComponent, AlertSuccessComponent, AlertWarningComponent,
  AlertInfoComponent, PasswordValidationTooltipComponent, CustomSpinnerComponent, CustomerInactivityModalComponent,
  CancelModalComponent, FirstnetSignupUtfModalComponent, CancelEligibilityStepModalComponent, CustomerInactivityUtfModalComponent,
  CustomerUtfCancelModalComponent, SessionTimeoutUtfModalComponent, UtfSyncDetailsPageComponent
} from './index';

@NgModule({
  declarations: [
    PageTitleComponent,
    AlertErrorComponent,
    LoadSpinnerComponent,
    ActivationSuccessComponent,
    MessageTooltipComponent,
    AlertSuccessComponent,
    AlertWarningComponent,
    AlertInfoComponent,
    PasswordValidationTooltipComponent,
    CustomSpinnerComponent,
    CustomerInactivityModalComponent,
    CancelModalComponent,
    CancelEligibilityStepModalComponent,
    CustomerInactivityUtfModalComponent,
    FirstnetSignupUtfModalComponent,
    CancelEligibilityStepModalComponent,
    CustomerUtfCancelModalComponent,
    SessionTimeoutUtfModalComponent,
    UtfSyncDetailsPageComponent
  ],
  imports: [
    CommonModule,
    CfetCoreModule,
    AbsMessagesModule,
    AbsTooltipModule,
    AbsExpandCollapseModule,
    FormsModule,
    ReactiveFormsModule,
    AbsModalsAndAlertsModule
  ],
  exports: [
    PageTitleComponent,
    AlertErrorComponent,
    LoadSpinnerComponent,
    ActivationSuccessComponent,
    MessageTooltipComponent,
    AlertSuccessComponent,
    AlertWarningComponent,
    AlertInfoComponent,
    PasswordValidationTooltipComponent,
    CustomSpinnerComponent,
    CustomerInactivityModalComponent,
    CancelModalComponent,
    CancelEligibilityStepModalComponent,
    CustomerInactivityUtfModalComponent,
    FirstnetSignupUtfModalComponent,
    CancelEligibilityStepModalComponent,
    CustomerUtfCancelModalComponent,
    SessionTimeoutUtfModalComponent,
    UtfSyncDetailsPageComponent]
})
export class CfetSharedModule { }
